import { DefaultQueryParams } from '@frontend/api-utils';
import { ChartClient } from '@frontend/chart/api';
import { IotsUptimeMetricChart } from '@frontend/chart/components';
import { Chart, ChartBinSize, ChartQueryParam } from '@frontend/chart/types';
import { useEffect, useState } from 'react';

import { getLast7DaysChartRange } from '../../pudo/last-30-days-chart-range';
import { Last7DaysHardwareIotsUptimeMetricChartProps } from './last-7-days-hardware-iots-uptime-metric-chart.component';

const toAverageUptimeChart = (chart: Chart): Chart | undefined => {
    const points = chart.series.flatMap((series) => series.data);
    if (points.length === 0) {
        return undefined;
    }

    const average = points.reduce((sum, point) => sum + point.value, 0) / points.length;

    return {
        series: [
            {
                name: 'Uptime',
                data: [{ label: 'last_7_days', value: average }]
            }
        ]
    };
};

export const useLast7DaysHardwareIotsUptimeMetricChart = (props: Last7DaysHardwareIotsUptimeMetricChartProps) => {
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        const { after, before } = getLast7DaysChartRange();

        ChartClient.fetchChartData(props.accountId, IotsUptimeMetricChart.definition, {
            [DefaultQueryParams.AFTER]: after,
            [DefaultQueryParams.BEFORE]: before,
            [ChartQueryParam.BIN_SIZE]: ChartBinSize.DAY
        })
            .then((chart) => {
                if (!cancelled) {
                    setData(toAverageUptimeChart(chart));
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return { data, isLoading, hasData: !!data };
};
